import classNames from 'classnames';
import { MobXProviderContext, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { checkFormGroup } from '../form-group/check-form-group'; // Note: TextInput CSS is served up via the react-form-components.global.css file;

/**
 * An array of sizes available for use for setting the Input size.
 * Was used when most input components were still Javascript.
 *
 * @deprecated Use the {@link InputSize} type in TypeScript instead.
 * @deprecated The 'large' size is considered deprecated.
 *
 * @privateRemarks
 * TODO: InputSize should be set to `'small' | 'medium' | 'large'` directly
 */

export const InputSizes = ['small', 'medium', 'large'];
/** The possible size of an input. */

/**
 * The TextInput component
 *
 * @remarks
 * A Udemy implementation of a `<input>` HTML tag. Default type is `type="text"`.
 *
 * This component requires global CSS.
 * You must add this import to your application's `_app.tsx` global CSS import manifest:
 *
 * @example
 * `@import '~@udemy/react-form-components/dist/react-form-components.global.css';`
 */
export const TextInput = observer( /*#__PURE__*/React.forwardRef((_ref, inputRef) => {
  let {
    size = 'medium',
    type = 'text',
    perfMetricName,
    className,
    ...htmlProps
  } = _ref;
  const {
    $$udFormGroup
  } = useContext(MobXProviderContext);
  const ariaProps = $$udFormGroup === null || $$udFormGroup === void 0 ? void 0 : $$udFormGroup.inputAriaProps;
  checkFormGroup('TextInput', {
    $$udFormGroup,
    ...htmlProps
  }, null, true);
  return /*#__PURE__*/React.createElement("input", Object.assign({}, ariaProps, htmlProps, {
    ref: inputRef,
    id: $$udFormGroup ? $$udFormGroup.id : htmlProps.id,
    type: type,
    className: classNames('ud-text-input', `ud-text-input-${size}`, size === 'large' ? 'ud-text-md' : 'ud-text-sm', $$udFormGroup.props.formControlClassName, className)
  }));
}));
TextInput.displayName = 'TextInput';
//# sourceMappingURL=text-input.react-component.js.map